import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { SignInModule } from "app/account/sign-in/sign-in.module";
import { ActivateModule } from "app/account/activate/activate.module";

import { AccountComponent } from 'app/account/account.component';
import { SignInComponent } from 'app/account/sign-in/sign-in.component';
import { ActivateComponent } from 'app/account/activate/activate.component';
import { ResetPasswordComponent } from "./resetPassword/resetPassword.component";
import { ResetPasswordModule } from "./resetPassword/resetPassword.module";
import { RestoreComponent } from "./restore/restore.component";
import { RestoreModule } from "./restore/restore.module";


const accountRoutes: Routes = [
  {
    path: "account",
    component: AccountComponent,
    children: [
      { path: 'signin', component: SignInComponent },
      { path: 'activate', component: ActivateComponent },
      { path: 'resetPassword', component: ResetPasswordComponent },
      { path: 'restore', component: RestoreComponent }
    ]
  }
];

@NgModule({
  imports: [
    SignInModule,
    ActivateModule,
    ResetPasswordModule,
    RestoreModule,
    RouterModule.forChild(accountRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AccountRoutingModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/account/account-routing.module.ts